import {
  runInAction,
  action,
  observable,
  computed,
  makeObservable,
} from 'mobx';
import { services } from '@project/API';
import { FetchStatus } from '@utils/fetchStatus';
import { UserModel } from './UserModel';

interface IUserController {
  value: FetchStatus<UserModel>;
  load(username: string): Promise<void>;
}

/**
 * Управление состоянием пользователя.
 *
 * Работа с полями пользователя происходит непосредственно через UserModel
 * Инициализация пользователя происходит в UserController
 */
export class UserController implements IUserController {
  @observable private _value: FetchStatus<UserModel> = { status: 'notLoaded' };

  constructor(private _services = services) {
    makeObservable<UserController>(this);
  }

  @computed get value(): FetchStatus<UserModel> {
    return this._value;
  }

  @action clear = () => {
    this._value = { status: 'notLoaded' };
  };

  @action load = async () => {
    try {
      runInAction(() => {
        this._value = { status: 'loading' };
      });

      const user = await this._services.users.getProfile();

      runInAction(() => {
        this._value = { status: 'loaded', result: new UserModel(user) };
      });
    } catch (e) {
      const message =
        e instanceof Error
          ? e.message
          : 'Не удалось получить данные пользователя';

      runInAction(() => {
        this._value = { status: 'error', error: message };
      });
    }
  };
}
